
export default {
    name: "WebApp",
    methods: {
        closeWebApp() {
            this.$store.dispatch("webAppPopup/toggleOverlay", false);
        }
    }
}
